export default {
    methods:{
        addCommas(value){
            return Math.round(value).toFixed(1).replace(/\d(?=(\d{3})+\.)/g, '$&,').slice(0,-2);
        },
        addCommasDecimal(value){
            return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        },
        addMoneyFormat(labelValue){
            // Nine Zeroes for Billions
            return Math.abs(Number(labelValue)) >= 1.0e+9
        
            ? (Math.abs(Number(labelValue)) / 1.0e+9).toFixed(1) + " B"
            // Six Zeroes for Millions
            : Math.abs(Number(labelValue)) >= 1.0e+6
        
            ? (Math.abs(Number(labelValue)) / 1.0e+6).toFixed(1) + " M"
            // Three Zeroes for Thousands
            : Math.abs(Number(labelValue)) >= 1.0e+3
        
            ? (Math.abs(Number(labelValue)) / 1.0e+3).toFixed(1) + " K"
        
            : Math.abs(Number(labelValue));
        },
        getDaysDifference(startDate, endDate){
            let difference = new Date(endDate) - new Date(startDate);
            const secondInDay = 86400;
            let daysDiference = Math.round(difference / 1000 / secondInDay);
            return daysDiference;
        },
        bytesToSize(bytes) {
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return '0 Byte';
            let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            return (bytes / Math.pow(1024, i)).toFixed(2) + ' ' + sizes[i];
        },
        copyToClipboard(str){
            const el = document.createElement('textarea');
            el.value = str;
            el.setAttribute('readonly', '');
            el.style.position = 'absolute';
            el.style.left = '-9999px';
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        }
    }
}